import { styled } from '@mui/material';

export const ActionsContainer = styled('div')`
  display: flex;
  flex-direction: column;
  padding-bottom: 5px;
  position: absolute;
  bottom: 0;
`;

export const ButtonsContainer = styled('div')`
  display: flex;
  padding-bottom: 5px;
  overflow: visible;
`;

export const ButtonContainer = styled('div')`
  position: relative;
  &:before {
    content: '';
    background-size: 100% auto;
    height: 6px;
    width: 18px;
    margin-bottom: 5px;
    opacity: 0;
    pointer-events: none;
    -webkit-transition: opacity 0.05s ease-out 0.05s;
    transition: opacity 0.05s ease-out 0.05s;
    bottom: 100%;
    left: 50%;
    position: absolute;
    z-index: 75;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
    -webkit-transform-origin: top;
    transform-origin: top;
    line-height: normal;
  }

  &:after {
    content: attr(data-balloon);
    padding: 6px;
    margin-bottom: 11px;
    background: rgba(0, 0, 0, 0.75);
    border-radius: 4px;
    color: #fff;
    font-family: Roboto;
    font-weight: 500;
    font-size: 11px;
    letter-spacing: 0.2px;
    white-space: nowrap;
    opacity: 0;
    pointer-events: none;
    -webkit-transition: opacity 0.05s ease-out 0.05s;
    transition: opacity 0.05s ease-out 0.05s;
    bottom: 100%;
    left: 50%;
    position: absolute;
    z-index: 75;
    -webkit-transform: translate(-50%);
    transform: translate(-50%);
    -webkit-transform-origin: top;
    transform-origin: top;
    line-height: normal;
  }
`;

export const ButtonStyled = styled('button')`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  min-width: 30px;
  width: 30px;
  height: 30px;
  padding: 0;
  color: #fff;
  margin-left: 5px;
  margin-right: 5px;
  position: relative;
  font-size: 1rem;
  line-height: 1.5;
  text-align: center;
  vertical-align: middle;
  border: 1px solid transparent;
  transition:
    color 0.15s ease-in-out,
    background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out,
    box-shadow 0.15s ease-in-out;
  cursor: pointer;
  transform: ${({ reelOpen }: { reelOpen: boolean }) => reelOpen && 'rotate(180deg)'};
`;

export const BottomBar = styled('div')`
  -webkit-transition: opacity 0.33s ease;
  transition: opacity 0.33s ease;
  position: fixed;
  bottom: ${({ reelOpen }: { reelOpen: boolean }) => (reelOpen ? '150px' : 0)};
  width: 100%;
  z-index: 100;
  -webkit-transition: bottom 0.3s ease;
  transition: bottom 0.3s ease;
`;
